import React from 'react';
import {Modal, ModalCloseButtonProps} from '@mantine/core';

export const EtroModalCloseButton: React.FC<ModalCloseButtonProps> = props => {
  return <Modal.CloseButton {...props} />;
};
